(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["enigma-product-grid"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    root.querySelectorAll('.epg-section').forEach(function(section){
      const list=section.querySelector('.epg-grid');
      const track=section.querySelector('.epg-scroll-progress');
      if(!list||!track||list.dataset.progressReady)return;
      list.dataset.progressReady='true';
      const thumb=track.querySelector('span');
      function update(){
        const max=list.scrollWidth-list.clientWidth;
        track.hidden=max<=1;
        if(max<=1)return;
        const width=Math.max(24,track.clientWidth*list.clientWidth/list.scrollWidth);
        thumb.style.width=width+'px';
        const fraction=Math.max(0,Math.min(1,list.scrollLeft/max));
        thumb.style.transform='translateX('+(fraction*(track.clientWidth-width))+'px)';
      }
      list.addEventListener('scroll',update,{passive:true});
      new ResizeObserver(update).observe(list);
      update();
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){init(document)});
  else init(document);
  document.addEventListener('shopify:section:load',function(event){init(event.target)});
})();

  } catch(e) { console.error(e); }
})();
})();
